import { CheckStroke, RefreshCircle1ClockwiseStroke, Search1Stroke, SignPostLeftStroke } from '@lineiconshq/free-icons';
import { ActionBarV2, ActionButtonV2 } from '@/components/custom/erp';

interface ActionBarProps {
  onSearchClick?: () => void;
  onRefreshClick?: () => void;
  onFixedColumnsClick?: () => void;
  className?: string;
  subTitle?: string;
}

export const ActionBar: React.FC<ActionBarProps> = ({
  onSearchClick,
  onRefreshClick,
  onFixedColumnsClick,
  className,
  subTitle
}) => {
  return (
    <ActionBarV2
      className={className}
      titleComponent={
        <div>
          <h1 className='my-1.5 text-xl font-bold'>Tất toán hóa đơn</h1>
          <div className='text-[10px] text-gray-500'>
            <p>
              <span className='mr-2 inline-block h-2 w-2 rounded-full bg-red-600'></span>
              <span className='font-semibold'>{subTitle}</span>
            </p>
          </div>
        </div>
      }
    >
      <ActionButtonV2 icon={CheckStroke} title='Tất toán' onClick={() => {}} variant='secondary' />

      {onSearchClick && <ActionButtonV2 icon={Search1Stroke} title='Tìm kiếm' onClick={onSearchClick} />}

      {onRefreshClick && (
        <ActionButtonV2
          icon={RefreshCircle1ClockwiseStroke}
          title='Refresh'
          onClick={onRefreshClick}
          variant='secondary'
        />
      )}
      {onFixedColumnsClick && (
        <ActionButtonV2
          icon={SignPostLeftStroke}
          title='Cố định cột'
          onClick={onFixedColumnsClick}
          variant='secondary'
        />
      )}
    </ActionBarV2>
  );
};

export default ActionBar;
